export const productSupplierCatalogItemFormSchema = {
  type: 'object',
  required: ['quantity', 'productId', 'supplierCatalogItemId'],
  properties: {
    quantity: { type: 'number', exclusiveMinimum: 0 },
  },
};
